import { createMachine } from 'xstate'

export const startDateAndPostFrequencyMobileMachine = (initial = 'home') =>
  createMachine({
    id: 'startDateAndPostFrequencyMobileModal',
    initial: initial,
    states: {
      home: {
        on: {
          CHOOSE_FREQUENCY: 'chooseFrequency',
          CHOOSE_TIME_OF_DAY: 'chooseTimeOfDay',
        },
      },
      chooseFrequency: {
        on: {
          GO_BACK: 'home',
          CHOOSE_SCHEDULE: 'customSchedule',
        },
      },
      customSchedule: {
        on: {
          GO_BACK: 'chooseFrequency',
        },
      },
      chooseTimeOfDay: {
        on: {
          GO_BACK: 'home',
          CONFIRM: 'home',
        },
      },
    },
  })
